import { useIntl } from "react-intl";
import { Typography, Box } from "@mui/material";
import Messages from "../../../../../localization/Messages";
import ChartComponent from "../../ChartComponent/ChartComponent";
import { DashboardStats } from "../../../../../models/stats";
import { getBookingStatusMessageDescriptor } from "../../../../../models/booking";
import { formatNumber } from "../../../../../helpers/numberDisplayHelper";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export type BookingAnalyticsProps = {
    dashboardStats: DashboardStats;
};

export const BookingByStatusAnalytics = ({ dashboardStats }: BookingAnalyticsProps) => {
    const intl = useIntl();
    const { bookingPerStatus } = dashboardStats;

    const totalBookings =
        bookingPerStatus.length > 0
            ? bookingPerStatus.reduce((acc, stat) => acc + stat.count, 0)
            : 0;

    return (
        <Box className="bookings-analytics-container shadow" my={2} mx={2.5} padding={2.5}>
            <Typography variant="h5">
                {intl.formatMessage(Messages.bookings)}{" "}
                <Tooltip title={intl.formatMessage(Messages.numberOfBookingsByStatusTooltip)}>
                    <HelpOutlineIcon fontSize="small" color="action" />
                </Tooltip>
            </Typography>
            <ChartComponent
                data={
                    bookingPerStatus.length > 0
                        ? bookingPerStatus.map(stat => {
                              return {
                                  label: intl.formatMessage(
                                      getBookingStatusMessageDescriptor(stat),
                                  ),
                                  value: stat.count,
                              };
                          })
                        : []
                }
                description={intl.formatMessage(Messages.numberOfBookingsByStatus)}
                outerStats={[
                    `${intl.formatMessage(Messages.totalNumberOfBookings)} = ${formatNumber(
                        totalBookings,
                    )}`,
                ]}
                formatter={value =>
                    `${formatNumber(value)} / ${((value / totalBookings) * 100).toFixed(2)}%`
                }
            />
        </Box>
    );
};

export default BookingByStatusAnalytics;
